var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckWithBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125 62.5C125 97.0179 97.0179 125 62.5 125C27.9821 125 0 97.0179 0 62.5C0 27.9821 27.9821 0 62.5 0C97.0179 0 125 27.9821 125 62.5ZM55.2707 95.5932L101.642 49.2223C103.216 47.6477 103.216 45.0945 101.642 43.5199L95.9393 37.8175C94.3647 36.2427 91.8115 36.2427 90.2366 37.8175L52.4194 75.6346L34.7634 57.9786C33.1888 56.404 30.6356 56.404 29.0607 57.9786L23.3584 63.681C21.7838 65.2555 21.7838 67.8087 23.3584 69.3833L49.568 95.593C51.1429 97.1678 53.6958 97.1678 55.2707 95.5932Z",
    fill: "#008393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWithBackground);
export default __webpack_public_path__ + "static/media/checkWithBackground.e14c01bdb5128d46c45b6fc7f4582ff0.svg";
export { ForwardRef as ReactComponent };